import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { ToggleSwitch } from '..';
import { uniTestkitFactoryCreator } from '@wix/wix-ui-test-utils/vanilla';
import { toggleSwitchDriverFactory } from './ToggleSwitch.driver';
import { delay } from '../utils';

const DATA_HOOK = 'ToggleSwitch-visual';
class ToggleSwitchVisual extends React.Component<any> {
  static defaultProps = {};
  state = { checked: false };

  async componentDidMount() {
    if (this.props.onToggle) {
      const toggleSwitchTestkitFactory = uniTestkitFactoryCreator(
        toggleSwitchDriverFactory,
      );
      const driver = toggleSwitchTestkitFactory({
        wrapper: document.body,
        dataHook: DATA_HOOK,
      });

      await driver.click();
    }
  }

  async componentDidUpdate(_prevProps, prevState) {
    if (this.props.onToggle && !prevState.checked && this.state.checked) {
      await delay(500);
      this.props.onToggle();
    }
  }

  render() {
    const { checked } = this.state;
    return (
      <VisualTestContainer>
        <ToggleSwitch
          onChange={() => this.setState({ checked: !checked })}
          checked={checked}
          data-hook={DATA_HOOK}
        />
      </VisualTestContainer>
    );
  }
}

const themedToggleSwitch = (props) => (
  <div
    style={
      {
        '--wst-primary-background-color-rgb': '255, 200, 0',
        '--wst-links-and-actions-color-rgb': '0, 55, 0',
        '--wst-paragraph-2-color-rgb': '0, 100, 155',
        '--wst-system-disabled-color-rgb': '20, 208, 28',
      } as React.CSSProperties
    }
  >
    {[
      {},
      { checked: true },
      { disabled: true },
      { checked: true, disabled: true },
    ].map((state, index) => (
      <div>
        <ToggleSwitch key={index} {...props} {...state} />
      </div>
    ))}
  </div>
);

visualize('ToggleSwitch', () => {
  story('basic', () => {
    snap('default', <ToggleSwitch />);
    snap('disabled', <ToggleSwitch disabled />);
    snap('checked', <ToggleSwitch checked />);
    snap('themed', themedToggleSwitch({}));
  });

  story('Async', () => {
    snap('toggle on', (done) => <ToggleSwitchVisual onToggle={done} />);
  });
});
